/* Loaded only on pages/nuora-gut-ritual-oc12. The product offer keeps gno-offer.js.
   Retry reads once; never retry a cart mutation with an uncertain outcome. */
(() => {
  "use strict";
  if (customElements.get("gno-offer")) return;

  class GnoOffer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector("[data-gno-form]");
      this.submitButton = this.querySelector("[data-gno-submit]");
      this.tiers = [...this.querySelectorAll("[data-gno-tier]")];
      if (!this.form || !this.submitButton) return;
      this.refills = this.querySelector("[data-gno-refills]");
      this.subscription = this.refills?.getAttribute("aria-checked") !== "false";
      this.updateMode();
      if (this.busy) this.state("loading");
      this.listen(this, "click", (event) => {
        if (
          event.target.closest("[data-gno-refills]") &&
          this.dataset.oneTime === "true" &&
          !this.busy
        ) {
          this.subscription = !this.subscription;
          this.updateMode();
        }
        const tier = event.target.closest("[data-gno-tier]");
        if (tier && !tier.disabled && !this.busy) this.select(tier);
      });
      this.listen(this, "keydown", (event) => {
        const tier = event.target.closest("[data-gno-tier]");
        if (!tier || this.busy || !this.available.length) return;
        const direction = {
          ArrowRight: 1,
          ArrowDown: 1,
          ArrowLeft: -1,
          ArrowUp: -1,
        }[event.key];
        if (!direction) return;
        event.preventDefault();
        const index = this.available.indexOf(tier);
        const next =
          this.available[
            (index + direction + this.available.length) % this.available.length
          ];
        this.select(next);
        next.focus();
      });
      const submitOffer = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.add();
      };
      this.listen(this.submitButton, "click", submitOffer);
      this.listen(this.form, "submit", submitOffer);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.resetTimer);
    }

    listen(target, event, handler) {
      target.addEventListener(event, handler, {
        signal: this.controller.signal,
      });
    }

    select(tier) {
      if (!this.available.includes(tier)) return;
      this.tiers.forEach((candidate) => {
        const selected = candidate === tier;
        candidate.setAttribute("aria-checked", String(selected));
        candidate.tabIndex = selected ? 0 : -1;
        candidate.parentElement.classList.toggle("is-selected", selected);
      });
      const cadence = this.querySelector("[data-gno-cadence]");
      if (cadence) cadence.textContent = tier.dataset.cadence || "";
      this.form.elements.quantity.value = tier.dataset.quantity;
      this.form.elements.selling_plan.value = tier.dataset.plan;
      const metadata = this.querySelector("[data-gno-kaching]");
      if (metadata) {
        const offer = {
          deal: this.dataset.kachingDeal,
          pp: Number(this.dataset.productId),
          main: true,
          v: this.dataset.kachingVersion,
          bid: tier.dataset.kachingBid,
        };
        if (this.subscription)
          offer.sellingPlan = {
            id: Number(tier.dataset.plan),
            priceAdjustment: {
              type: "price",
              value: Number(tier.dataset.subCents),
            },
          };
        metadata.value = JSON.stringify(offer);
      }
      this.querySelector("[data-gno-error]").hidden = true;
    }

    updateMode() {
      this.available = this.tiers.filter((tier) =>
        this.subscription
          ? tier.dataset.available === "true"
          : this.dataset.oneTime === "true",
      );
      this.form.elements.selling_plan.disabled = !this.subscription;
      this.refills?.setAttribute(
        "aria-checked",
        String(this.subscription),
      );
      const prefix = this.subscription ? "sub" : "once";
      this.tiers.forEach((tier) => {
        const card = tier.parentElement;
        tier.disabled = !this.available.includes(tier);
        card.querySelector("[data-gno-price]").textContent =
          tier.dataset[`${prefix}Price`];
        card.querySelector("[data-gno-daily]").textContent =
          tier.dataset[`${prefix}Daily`];
        card.querySelector("[data-gno-savings]").textContent =
          tier.dataset[`${prefix}Savings`];
        card.querySelector(".gno-offer__saving").hidden =
          Number(tier.dataset[`${prefix}SavingsCents`]) <= 0;
        card.querySelector(".gno-offer__unavailable").hidden = !tier.disabled;
      });
      const selected =
        this.available.find(
          (tier) => tier.getAttribute("aria-checked") === "true",
        ) ||
        this.available.find(
          (tier) => tier.dataset.quantity === this.dataset.defaultQuantity,
        ) ||
        this.available[0];
      if (selected) this.select(selected);
      this.submitButton.disabled = !selected;
      const planError = this.querySelector("[data-gno-plan-error]");
      if (planError) planError.hidden = Boolean(selected);
    }

    state(value) {
      for (const name of ["idle", "loading", "added"]) {
        this.querySelector(`[data-gno-${name}]`).hidden = name !== value;
      }
      this.querySelector("[data-gno-spinner]").hidden = value !== "loading";
      this.submitButton.setAttribute("aria-busy", String(value === "loading"));
      this.submitButton.disabled =
        value === "loading" || !this.available.length;
      this.tiers.forEach((tier) => {
        tier.disabled = value === "loading" || !this.available.includes(tier);
      });
      if (this.refills)
        this.refills.disabled =
          value === "loading" || this.dataset.oneTime !== "true";
    }

    async add() {
      if (this.busy || !this.available.length) return;
      if (this.cartReviewRequired) {
        window.location.assign(this.cartUrl);
        return;
      }
      this.busy = true;
      clearTimeout(this.resetTimer);
      const errorOutput = this.querySelector("[data-gno-error]");
      try {
        errorOutput.hidden = true;
        this.state("loading");
        const root = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
        this.cartUrl = `${root}cart`;
        const drawer = document.querySelector("cart-drawer");
        let body = new FormData(this.form);
        const variant = Number(body.get("id"));
        const quantity = Number(body.get("quantity"));
        const plan = this.subscription ? Number(body.get("selling_plan")) : null;
        const selected = this.available.find(
          (tier) => tier.getAttribute("aria-checked") === "true",
        );
        if (
          !Number.isSafeInteger(variant) || variant <= 0 ||
          !Number.isSafeInteger(quantity) || quantity <= 0 ||
          !selected || quantity !== Number(selected.dataset.quantity) ||
          (this.subscription && (!Number.isSafeInteger(plan) || plan <= 0 ||
            plan !== Number(selected.dataset.plan)))
        ) throw new Error("invalid-selection");
        // The offer already builds its bundle payload; skip Kaching's fetch rewriting.
        const addEndpoint = `${root}cart/add.js?kaching_bundles=true`;
        let endpoint = addEndpoint;
        const headers = { Accept: "application/json" };
        let sections = [];
        try {
          sections =
            drawer
              ?.getSectionsToRender?.()
              .map((section) => section.id || section.section)
              .filter(Boolean)
              .slice(0, 5) || [];
        } catch {
          /* The cart page is the fallback. */
        }
        if (sections.length) {
          body.set("sections", sections.slice(0, 5).join(","));
          body.set("sections_url", location.pathname);
        }
        let expected = null;
        if (this.dataset.kachingDeal) {
          const cart = await this.readCart(root, "before-add");
          const existingIndex = cart.items.findIndex(
            (item) =>
              Number(item.variant_id) === variant &&
              item.properties?._nuora_offer === this.dataset.offerId &&
              item.properties?._nuora_role === "main",
          );
          const existing = cart.items[existingIndex];
          const properties = { ...existing?.properties };
          for (const [key, value] of body) {
            const match = /^properties\[(.+)\]$/.exec(key);
            if (match) properties[match[1]] = value;
          }
          expected = { variant, quantity, plan, properties };
          let payload;
          if (existing) {
            // Changing the existing offer avoids removing it before a replacement succeeds.
            endpoint = `${root}cart/change.js`;
            payload = {
              line: existingIndex + 1,
              quantity,
              properties,
              selling_plan: plan,
            };
          } else {
            const item = { id: variant, quantity, properties };
            if (this.subscription) item.selling_plan = plan;
            payload = { items: [item] };
          }
          if (sections.length)
            Object.assign(payload, {
              sections,
              sections_url: location.pathname,
            });
          body = JSON.stringify(payload);
          headers["Content-Type"] = "application/json";
        }
        // Do not abort or retry a cart mutation when its section is removed in the editor.
        const { result, recovered } = await this.submitCart(endpoint, {
          method: "POST",
          credentials: "same-origin",
          headers,
          body,
        }, root, expected);
        this.state("added");
        let cart = result;
        if (!recovered && this.dataset.kachingDeal && endpoint === addEndpoint) {
          try {
            const fresh = await fetch(`${root}cart.js`, {
              credentials: "same-origin",
              headers: { Accept: "application/json" },
            });
            if (fresh.ok) cart = await fresh.json();
          } catch {
            /* Cart presentation can refresh independently of the successful add. */
          }
        }
        let opened = await this.openAppCart(cart, result);
        if (
          !opened &&
          this.isConnected &&
          drawer &&
          sections.length &&
          sections.every((id) => result.sections?.[id])
        ) {
          try {
            drawer.setActiveElement?.(this.submitButton);
            drawer.renderContents(result);
            opened = true;
          } catch {
            /* The item was added successfully. Never add it again. */
          }
        }
        this.dispatchEvent(
          new CustomEvent("gno:cart-added", {
            bubbles: true,
            detail: { response: result },
          }),
        );
        if (!opened) {
          window.location.assign(`${root}cart`);
          return;
        }
        if (this.isConnected)
          this.resetTimer = setTimeout(() => this.state("idle"), 1800);
      } catch (error) {
        if (this.isConnected) {
          this.state("idle");
          errorOutput.textContent = error.publicMessage || this.dataset.error ||
            "We couldn't update your cart. Please try again.";
          if (error.reviewCart) {
            this.cartReviewRequired = true;
            this.querySelector("[data-gno-idle]").textContent = "View cart";
            errorOutput.textContent = "We couldn't confirm your cart update. Please check your cart before trying again.";
          }
          errorOutput.hidden = false;
        }
      } finally {
        this.busy = false;
      }
    }

    async readResponse(response) {
      const failure = new Error("cart-response");
      failure.diagnostic = {
        status: response.status,
        contentType: response.headers.get("content-type"),
        redirected: response.redirected,
      };
      let result;
      try {
        result = JSON.parse(await response.text());
      } catch {
        failure.diagnostic.reason = "unreadable-json";
        throw failure;
      }
      if (!result || typeof result !== "object" || Array.isArray(result)) {
        failure.diagnostic.reason = "invalid-json-shape";
        throw failure;
      }
      if (!response.ok || Number(result.status) >= 400) {
        failure.diagnostic.reason = "api-error";
        const status = Number(result.status) || response.status;
        failure.rejected = status >= 400 && status < 500;
        const message = result.description || result.message;
        if (failure.rejected && typeof message === "string")
          failure.publicMessage = message.slice(0, 300);
        throw failure;
      }
      return result;
    }

    diagnose(error, phase) {
      // In-memory, bounded diagnostics only: no response bodies, tokens or customer data.
      const detail = { phase, reason: error.name || "request-error", ...error.diagnostic };
      this.cartDiagnostics = [...(this.cartDiagnostics || []), detail].slice(-5);
      console.warn("[GNO page cart]", detail);
    }

    async readCart(root, phase) {
      for (let attempt = 0; attempt < 2; attempt++) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(`${root}cart.js`, {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
            cache: "no-store",
            signal: controller.signal,
          });
          const cart = await this.readResponse(response);
          if (!Array.isArray(cart.items)) throw new Error("invalid-cart-shape");
          return cart;
        } catch (error) {
          this.diagnose(error, phase);
          if (attempt || error.rejected) throw error;
        } finally {
          clearTimeout(timer);
        }
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    }

    async submitCart(endpoint, options, root, expected) {
      try {
        const response = await fetch(endpoint, options);
        const result = await this.readResponse(response);
        if (!(Array.isArray(result.items) && result.items.length) &&
          !(Number.isSafeInteger(result.id) && result.id > 0))
          throw new Error("invalid-mutation-shape");
        return { result, recovered: false };
      } catch (error) {
        this.diagnose(error, "submit");
        if (error.rejected) throw error;
        // The request may have succeeded. Read back the exact offer; never send it again.
        if (expected) {
          try {
            const cart = await this.readCart(root, "confirm-add");
            const matches = cart.items.filter((item) =>
              Number(item.variant_id) === expected.variant &&
              item.properties?._nuora_offer === expected.properties._nuora_offer &&
              item.properties?._nuora_role === expected.properties._nuora_role,
            );
            const item = matches.length === 1 && matches[0];
            if (item && Number(item.quantity) === expected.quantity &&
              (Number(item.selling_plan_allocation?.selling_plan?.id) || null) === expected.plan &&
              Object.entries(expected.properties).every(([key, value]) =>
                item.properties?.[key] === value,
              )) return { result: cart, recovered: true };
          } catch {
            // The cart page lets the customer check an outcome we cannot verify.
          }
        }
        error.reviewCart = true;
        throw error;
      }
    }

    async openAppCart(cart, response) {
      if (!this.isConnected) return false;
      const detail = { cart, response, source: "gut-capsule-new-offer" };
      for (const name of ["cart:add", "cart:refresh", "cart:updated"])
        document.dispatchEvent(
          new CustomEvent(name, { bubbles: true, detail }),
        );
      window.dispatchEvent(new CustomEvent("cart:updated", { detail }));
      try {
        if (typeof window.NuoraUpcart?.open === "function") {
          const opened = await window.NuoraUpcart.open();
          if (opened !== false) return true;
        }
      } catch {
        /* Try the app's public API or the native drawer. */
      }
      try {
        if (typeof window.upcartOpenCart === "function") {
          await window.upcartRefreshCart?.();
          await window.upcartOpenCart();
          return true;
        }
        if (typeof window.Upcart?.open === "function") {
          await window.Upcart.open();
          return true;
        }
      } catch {
        /* A presentation failure must never submit the offer again. */
      }
      return false;
    }
  }
  customElements.define("gno-offer", GnoOffer);
})();
